module.exports = __webpack_public_path__ + "static/media/Grassi-Sangiovese.43c52409.jpg";